import { Box, Chip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationNiche } from "schemas/dashboard";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";
import { generateColorFromString } from "utils/color";
import { trackEvent } from "utils/tracking";

import TemplateChip from "./TemplateChip";
import styles from "./styles";

interface Props {
  niche: OrganizationNiche;
  editNiche: (niche: OrganizationNiche) => void;
}
const NicheCard = ({ niche, editNiche }: Props) => {
  const getNicheTemplates = () => {
    if (niche?.templates && niche.templates.length > 0) {
      return niche?.templates;
    } else {
      return [];
    }
  };

  const nicheTemplates = getNicheTemplates();

  return (
    <Box
      sx={styles.card}
      onClick={() => {
        trackEvent("VA Onboarding - Edit Niche Clicked", {
          "Niche Name": niche.name,
        });
        editNiche(niche);
      }}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        <Box
          component="i"
          className="fa-regular fa-pen"
          sx={{ color: grey[600], fontSize: 14 }}
        />
      </Box>

      <Box>
        <Chip
          sx={{
            backgroundColor: generateColorFromString(
              niche.name,
              "tagColorPalette",
            ),
            fontSize: 14,
            px: 1,
            mb: 3,
          }}
          label={niche.name}
        />
      </Box>

      <Box>
        {nicheTemplates?.map((template, index) => (
          <TemplateChip key={template.id} template={template} index={index} />
        ))}
        {nicheTemplates?.length === 0 && (
          <>
            <Typography sx={{ color: "black" }}>
              No templates set yet
            </Typography>

            <StyledLargeButton fullWidth styles={{ mt: 2 }}>
              Set your templates
            </StyledLargeButton>
          </>
        )}
      </Box>
    </Box>
  );
};

export default NicheCard;
